import api from "../utils/api";

export const createUser = (data) => api.post("/users", data);

export const createRole = (data) => api.post("/admin/roles", data);

export const getRoles = () => api.get("/admin/roles");

export const createModule = (data) => api.post("/admin/modules", data);

export const getModules = () => api.get("/admin/modules");

export const assignPermissions = (roleId, data) =>
  api.post(`/admin/roles/${roleId}/permissions`, data);

export const getUsers = () => api.get("/users");

export const toggleUserStatus = (userId) =>
  api.post(`/users/${userId}/toggle-status`);

export const getUserLoginHistory = (userId) =>
  api.get(`/users/${userId}/login-history`);
